module.exports = __webpack_public_path__ + "img/cash-return-1@2x.603a4b8b.png";